const TOLERANCE = 0.0001;

export const isBelowTolerance = (num: number) => {
  return Math.abs(num) < TOLERANCE;
};
